import React, { useState } from "react";
import DayPermission from "../../../../components/dayPermission/DayPermission";
import ApplyLeave from "./ApplyLeave";
import AttendanceHome from "./AttendanceHome";

const SwitchAttendance = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <AttendanceHome />
          </div>
        );

      case 2:
        return (
          <div>
            <ApplyLeave />
          </div>
        );

      case 3:
        return (
          <div>
            <DayPermission mode="requester" />
          </div>
        );

      default:
        return (
          <div>
            <AttendanceHome />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Home</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Apply Leave</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Day Permission</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchAttendance;
